import React from 'react'
import compoundingPointsIcon from '../../assets/coins/compounding.svg'

export const CompoundingIcon = () => {
  return (
    <img src={compoundingPointsIcon}/>
  )
}